import 'css-chunksrc/client/pages/projectPage/synthesisPage/reports/reportsList/styles.scss';export default {
  "reportsList": "_reportsList_mscbq_1",
  "report": "_report_mscbq_1"
};